import React from "react";
import "./FRFooter.css";
import { NavLink } from "react-router-dom";

function frFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="footer-container">
        <div className="footer-link">
          <span className="border">
            <NavLink to="/fr/privacypolicy">Politique de confidentialité</NavLink>
          </span>
          <span className="hide-mobile"> | </span>
          <span className="border">
            <NavLink to="/fr/legalnotice">Mentions légales</NavLink>
          </span>
          <span className="hide-mobile"> | </span>
          <span>
            <NavLink to="/fr/contactus" id="contact-us-link-footer">
              Contactez-nous
            </NavLink>
          </span>
        </div>
        <div className="footer-copyright">
          <span>
            &copy; {currentYear} Applied Medical Resources Corporation | Tous droits réservés.
          </span>
        </div>
      </div>
    </>
  );
}

export default frFooter;
